"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./StatusTag.scss");
var StatusTagProps_1 = require("./StatusTagProps");
var StatusTagsStylesMaps_1 = require("./StatusTagsStylesMaps");
var StatusTag = function (props) {
    var getTypeStyle = function (type) {
        if (type) {
            return StatusTagsStylesMaps_1.typeMap.get(type);
        }
        return null;
    };
    var tagClasses = [
        styles.tag,
        getTypeStyle(StatusTagProps_1.StatusTagType[props.type]),
        "inline-flex flex-items-center pill-radius type-sm color-ui-white text-center font-medium pad-l-xxs pad-r-xxs",
    ];
    var accessibilityText = props.accessibilityText, className = props.className, testId = props.testId;
    return (React.createElement("div", { "data-testid": testId, className: [className, tagClasses.join(" ")].join(" ") },
        React.createElement("span", { className: "hidden-spoken" }, accessibilityText ? accessibilityText : props.type),
        React.createElement("span", { "aria-hidden": true }, props.type)));
};
exports.default = StatusTag;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/StatusTag/StatusTag.js
// module id = 1818
// module chunks = 8